export const BACKGROUND_TYPES = ['image', 'color'] as const

export const CUSTOM_THEME_CODE_ID = 7

export const EMPTY_FOOTER_TAG = '<p></p>'
